import { Translation } from 'cng-common/features/translations/components/translation'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'
import { INITIATIVES_EDITOR_TYPE_STEPS } from 'partner360/features/keyInitiativeEditor/model/editorConfig'

import { TRANSLATION_KEYS as tr } from '../../../../../../translations'
import { INITIATIVES_EDITOR_TYPES } from '../../../configs'

import styles from './WidgetView.module.scss'

interface IWidgetViewProps {
  value: number
  onOptionClick: (newValue: number) => void
}

export const WidgetView = ({ value, onOptionClick }: IWidgetViewProps) => {
  /** -------------------- Variables ----------------------- */

  const widgetViewTitle = `${tr.keyInitiativesFormat}-widget-view`

  /** -------------------- Render ----------------------- */

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Translation text={widgetViewTitle} />
      </div>
      <RowButtons
        generateTranslationKey={(option) =>
          `${tr.keyInitiativesFormat}-${option}-${option === INITIATIVES_EDITOR_TYPE_STEPS ? 'on' : 'off'}`
        }
        value={value}
        options={INITIATIVES_EDITOR_TYPES}
        onOptionClick={onOptionClick}
        containerClassName={styles.switcher}
      />
    </div>
  )
}
